(function () {
  const loaderScript = document.currentScript;

  const ROUTINE_ENDPOINT = loaderScript.dataset.bmrEndpoint || '/pages/build-my-routine';

  const ASSETS = {
    css: loaderScript.dataset.bmrCss,
    scripts: [
      loaderScript.dataset.bmrConfig,
      loaderScript.dataset.bmrHelpers,
      loaderScript.dataset.bmrClassification,
      loaderScript.dataset.bmrScoring,
      loaderScript.dataset.bmrData,
      loaderScript.dataset.bmrRender,
      loaderScript.dataset.bmrMain
    ].filter(Boolean)
  };

  let loadPromise = null;

  function loadCssOnce(href) {
    if (!href || document.querySelector('link[data-bmr-css="true"]')) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.bmrCss = 'true';
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScriptOnce(src) {
    if (!src) return Promise.resolve();

    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset.bmrLazyScript = 'true';
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  async function injectDrawerHtml() {
    if (document.getElementById('build-my-routine-root')) return;

    const response = await fetch(ROUTINE_ENDPOINT, {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Could not load Build My Routine HTML.');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const root = doc.getElementById('build-my-routine-root');

      if (!root) throw new Error('Build My Routine root was not found.');

    document.body.appendChild(root);

    const disclaimer = doc.getElementById('build-my-routine-disclaimer');
    if (disclaimer && !document.getElementById('build-my-routine-disclaimer')) {
      document.body.appendChild(disclaimer);
    }
  }

  async function loadRoutineBuilder(shouldOpen = false) {
    if (window.__bmrReady && document.getElementById('build-my-routine-root')) return;

    if (!loadPromise) {
      loadPromise = (async () => {
        if (shouldOpen) window.__bmrRequestedOpen = true;
        window.__bmrProductDataBaseUrl = ROUTINE_ENDPOINT;

        await injectDrawerHtml();
        await loadCssOnce(ASSETS.css);

        for (const src of ASSETS.scripts) {
  console.log('[BuildMyRoutine] loading script:', src);
  await loadScriptOnce(src);
  console.log('[BuildMyRoutine] loaded script:', src);
}
      })();
    }

    return loadPromise;
  }
loadRoutineBuilder(false).catch(console.error);
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-build-routine-open]');
    if (!trigger) return;

    if (window.__bmrReady && document.getElementById('build-my-routine-root')) return;

    event.preventDefault();
    window.__bmrRequestedOpen = true;
try {
  await loadRoutineBuilder(true);

  if (window.__bmrReady) {
    trigger.click();
  }
} catch (error) {
  console.error('[BuildMyRoutine] lazy load failed:', error);
}
  }, true);
})();